import React, { useRef } from "react";
import { Card, Flex, Divider, Layout, Typography, Button, Row, Col } from "antd";
import "./styles.scss";
import { CheckCircleFilled } from "@ant-design/icons";
import { MusicIcon } from "components/Icons/MusicIcon";
import { ComputerIcon } from "components/Icons/ComputerIcon";
import { LiveIcon } from "components/Icons";

const SweatbaseLogo = (props) => (
	<svg width="190" height="24" viewBox="0 0 190 24" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.100792 20.4537C2.1542 22.9234 5.42682 24 8.60317 24C12.4533 24 16.7526 21.9736 16.7526 17.6675C16.7526 13.104 12.4332 11.4005 8.87653 9.99777C6.38737 9.01607 4.27176 8.18169 4.27176 6.6174C4.27176 4.40104 6.13266 3.73614 8.05773 3.73614C10.0149 3.73614 11.8116 4.49603 13.2554 5.76251C13.4158 5.92083 13.6404 5.92083 13.8329 5.73085L15.7902 3.54617C15.9505 3.38785 15.9505 3.13456 15.7581 2.97625C13.6404 1.23483 10.9453 0 8.18607 0C4.14343 0 0.485805 2.15303 0.485805 6.49075C0.485805 10.5989 4.49245 12.2371 7.96549 13.6571C10.6222 14.7434 12.9667 15.702 12.9667 17.5408C12.9667 19.6306 10.432 20.2638 8.7315 20.2638C6.64602 20.2638 4.49636 19.7573 3.08465 18.1424C2.92423 17.9524 2.69963 17.9524 2.50712 18.0791L0.164961 19.8838C-0.0275457 20.0421 -0.0596299 20.2638 0.100792 20.4537ZM18.5091 1.29817L27.6852 23.1133C27.7494 23.2718 27.9419 23.3983 28.1664 23.3983C28.359 23.3983 28.5515 23.2718 28.6157 23.1133L33.3962 12.2533C33.4925 12 33.6529 11.905 33.7492 11.905C33.8776 11.905 34.0058 12.0317 34.102 12.2533L38.8827 23.1133C38.9469 23.2718 39.1393 23.3983 39.3639 23.3983C39.5565 23.3983 39.749 23.2718 39.8132 23.1133L41.1928 19.8206C41.289 19.5988 41.289 19.2822 41.1928 19.0607L34.2304 3.60951C34.1662 3.4512 33.9737 3.32456 33.7492 3.32456C33.5567 3.32456 33.332 3.4512 33.2679 3.60951L28.6478 13.9314C28.5194 14.1846 28.4231 14.3113 28.2948 14.3113C28.1664 14.3113 28.0061 14.1846 27.9098 13.9314L22.5838 1.29817C22.4875 1.07654 22.2629 0.918223 22.0063 0.918223H18.7658C18.5091 0.918223 18.4128 1.07654 18.5091 1.29817ZM40.6153 12.2533L42.444 16.1478C42.5403 16.3693 42.6686 16.3693 42.7649 16.1478L48.9893 1.29817C49.0856 1.07654 48.9893 0.918223 48.7326 0.918223H45.5242C45.2675 0.918223 45.0428 1.07654 44.9466 1.29817L40.6153 11.4934C40.519 11.7467 40.519 12.0317 40.6153 12.2533ZM52.6564 13.7731C52.3996 13.7731 52.2393 13.6148 52.2393 13.3615V10.6385C52.2393 10.3852 52.3996 10.2269 52.6564 10.2269H66.3565C66.6132 10.2269 66.7735 10.3852 66.7735 10.6385V13.3615C66.7735 13.6148 66.6132 13.7731 66.3565 13.7731H52.6564ZM52.2393 22.6701V19.9472C52.2393 19.6939 52.3996 19.5356 52.6564 19.5356H66.3565C66.6132 19.5356 66.7735 19.6939 66.7735 19.9472V22.6701C66.7735 22.9234 66.6132 23.0817 66.3565 23.0817H52.6564C52.3996 23.0817 52.2393 22.9234 52.2393 22.6701ZM66.3565 4.4644H52.6564C52.3996 4.4644 52.2393 4.30608 52.2393 4.05279V1.32983C52.2393 1.07654 52.3996 0.918223 52.6564 0.918223H66.3565C66.6132 0.918223 66.7735 1.07654 66.7735 1.32983V4.05279C66.7735 4.30608 66.6132 4.4644 66.3565 4.4644ZM70.2738 23.0815H73.4502C73.6747 23.0815 73.9315 22.9232 74.0277 22.7016L80.2522 9.40343C80.3804 9.15014 80.5087 9.02349 80.6371 9.02349C80.7655 9.02349 80.8938 9.15014 81.0222 9.40343L83.9097 15.6092C84.1343 16.1159 83.9418 16.4325 83.3964 16.4325H80.188C79.9313 16.4325 79.7066 16.5908 79.6104 16.8123L78.295 19.5986C78.1987 19.8203 78.295 19.9786 78.5517 19.9786H85.0327C85.5781 19.9786 86.0915 20.2952 86.316 20.7701L87.2144 22.7016C87.3107 22.9232 87.5674 23.0815 87.8241 23.0815H90.9683C91.2251 23.0815 91.3212 22.9232 91.2251 22.7016L81.0864 0.886305C81.0222 0.727991 80.8296 0.601348 80.6371 0.601348C80.4446 0.601348 80.2201 0.727991 80.1559 0.886305L70.0172 22.7016C69.9209 22.9232 70.0172 23.0815 70.2738 23.0815ZM108.444 4.4644H90.7978C90.541 4.4644 90.3806 4.30608 90.3806 4.05279V1.32983C90.3806 1.07654 90.541 0.918223 90.7978 0.918223H108.444C108.701 0.918223 108.861 1.07654 108.861 1.32983V4.05279C108.861 4.30608 108.701 4.4644 108.444 4.4644ZM98.0809 23.0817C97.8562 23.0817 97.6638 22.9234 97.6638 22.6701V7.94724C97.6638 7.69393 97.8562 7.53562 98.0809 7.53562H101.097C101.353 7.53562 101.514 7.69393 101.514 7.94724V22.6701C101.514 22.9234 101.353 23.0817 101.097 23.0817H98.0809ZM112.889 23.0817H122.065C129.445 23.0817 131.017 14.7229 126.749 11.1768C126.332 10.8285 126.268 10.3536 126.525 9.87862C128.386 6.42745 126.685 1.48814 121.167 0.949883C120.814 0.918223 120.268 0.918223 119.338 0.918223H112.889C112.632 0.918223 112.472 1.07654 112.472 1.32983V22.6701C112.472 22.9234 112.632 23.0817 112.889 23.0817ZM116.322 14.0581C116.322 13.5198 116.675 13.1715 117.22 13.1715H122.065C126.14 13.1715 126.14 19.5356 122.065 19.5356H117.22C116.675 19.5356 116.322 19.1874 116.322 18.649V14.0581ZM116.322 8.70712V5.31927C116.322 4.78101 116.675 4.43272 117.22 4.43272H120.268C124.118 4.43272 124.311 9.1504 120.782 9.562C120.461 9.59366 119.883 9.59366 118.985 9.59366H117.22C116.675 9.59366 116.322 9.24538 116.322 8.70712ZM134.646 23.0815H131.47C131.213 23.0815 131.117 22.9232 131.213 22.7016L141.352 0.886305C141.416 0.727991 141.641 0.601348 141.833 0.601348C142.026 0.601348 142.218 0.727991 142.283 0.886305L152.421 22.7016C152.518 22.9232 152.421 23.0815 152.165 23.0815H149.02C148.763 23.0815 148.506 22.9232 148.41 22.7016L147.513 20.7701C147.288 20.2952 146.775 19.9786 146.229 19.9786H139.748C139.491 19.9786 139.395 19.8203 139.491 19.5986L140.807 16.8123C140.903 16.5908 141.128 16.4325 141.384 16.4325H144.593C145.138 16.4325 145.331 16.1159 145.106 15.6092L142.218 9.40343C142.09 9.15014 141.962 9.02349 141.833 9.02349C141.705 9.02349 141.577 9.15014 141.448 9.40343L135.224 22.7016C135.128 22.9232 134.871 23.0815 134.646 23.0815ZM155.101 20.4537C157.154 22.9234 160.427 24 163.604 24C167.453 24 171.753 21.9736 171.753 17.6675C171.753 13.3784 167.907 11.7665 164.487 10.3329C161.898 9.24789 159.553 8.26504 159.304 6.30077C159.272 6.04748 159.111 5.88916 158.855 5.88916H155.934C155.679 5.88916 155.487 6.07914 155.487 6.30077C155.487 10.5334 159.525 12.2046 163.007 13.6456C165.647 14.7379 167.967 15.6979 167.967 17.5408C167.967 19.6306 165.432 20.2638 163.732 20.2638C161.646 20.2638 159.496 19.7573 158.084 18.1424C157.924 17.9524 157.699 17.9524 157.507 18.0791L155.166 19.8838C154.973 20.0421 154.941 20.2638 155.101 20.4537ZM159.047 1.3298L160.459 3.83112C160.587 4.05277 160.78 4.11609 161.037 4.02109C161.678 3.79946 162.417 3.73614 163.058 3.73614C165.014 3.73614 166.811 4.49603 168.255 5.76251C168.416 5.92083 168.641 5.92083 168.833 5.73085L170.791 3.54617C170.951 3.38785 170.951 3.13456 170.758 2.97625C168.641 1.23483 165.945 0 163.187 0C161.775 0 160.395 0.28496 159.208 0.791559C158.983 0.886539 158.919 1.13985 159.047 1.3298ZM175.885 13.7731C175.629 13.7731 175.468 13.6148 175.468 13.3615V10.6385C175.468 10.3852 175.629 10.2269 175.885 10.2269H189.585C189.841 10.2269 190.002 10.3852 190.002 10.6385V13.3615C190.002 13.6148 189.841 13.7731 189.585 13.7731H175.885ZM175.468 22.6701V19.9472C175.468 19.6939 175.629 19.5356 175.885 19.5356H189.585C189.841 19.5356 190.002 19.6939 190.002 19.9472V22.6701C190.002 22.9234 189.841 23.0817 189.585 23.0817H175.885C175.629 23.0817 175.468 22.9234 175.468 22.6701ZM189.585 4.4644H175.885C175.629 4.4644 175.468 4.30608 175.468 4.05279V1.32983C175.468 1.07654 175.629 0.918223 175.885 0.918223H189.585C189.841 0.918223 190.002 1.07654 190.002 1.32983V4.05279C190.002 4.30608 189.841 4.4644 189.585 4.4644Z"
			fill="currentColor"
		/>
	</svg>
);

const { Content } = Layout;

const LandingPage = ({ image, color, gymName, description }) => {
	const getImageUrl = (image) => {
		if (!image) return "";
		if (typeof image === "string") {
			return image;
		}
		return URL.createObjectURL(image);
	};

	const imageUrl = getImageUrl(image);
	const ref = useRef(null);

	const isMobile = window.innerWidth < 576;
	const infoCard = (
		<Card className="info-card">
			<Typography.Title level={3}>Membership</Typography.Title>
			<Typography.Paragraph style={{ fontSize: 8 }}>
				Access our digital content powered by popular music to keep you sweating from home, when traveling, or when you
				just don't have time for class.
			</Typography.Paragraph>
			<Divider />
			<Button className="started-btn" style={{ backgroundColor: color, color: "#FFF", minWidth: "unset" }}>
				LET'S GET STARTED
			</Button>
			<Flex gap={8}>
				<CheckCircleFilled style={{ color }} />
				<Typography.Text>On Demand Workouts</Typography.Text>
			</Flex>
			<Flex gap={8}>
				<CheckCircleFilled style={{ color }} />
				<Typography.Text>Live Workouts</Typography.Text>
			</Flex>
			<Flex gap={8}>
				<CheckCircleFilled style={{ color }} />
				<Typography.Text>Access workouts from any device on the SWEATBASE App</Typography.Text>
			</Flex>
		</Card>
	);
	if (isMobile) {
		return (
			<div className="landing-page">
				<div
					ref={ref}
					style={{
						backgroundImage: `url(${imageUrl})`,
						width: "100%",
						height: ref?.current?.offsetWidth * 0.4,
						backgroundPosition: "center",
						backgroundSize: "cover",
					}}
				>
					<div
						style={{
							background: "linear-gradient(0deg, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5))",
							height: "100%",
							padding: 20,
						}}
					>
						<Flex className="landing-page" justify="space-between">
							<SweatbaseLogo style={{ textAlign: "left", color: "#fff", height: 16, width: 120 }} />
							<Typography.Text
								style={{ textAlign: "left", color: "#fff", margin: 0, fontSize: 16, marginTop: -4 }}
								level={3}
							>
								LOGIN
							</Typography.Text>
						</Flex>
					</div>
				</div>
				<div className="mobile-content">
					<Flex className="content" justify="center" flex={5} vertical>
						<Typography.Title style={{ textAlign: "center", color: "#fff" }} level={5}>
							{gymName}
						</Typography.Title>
						<Typography.Paragraph style={{ fontSize: 8, textAlign: "center", color: "#fff" }}>
							{description?.substring(0, 100)}
						</Typography.Paragraph>
					</Flex>
					<Flex justify="center" align="center">
						<div style={{ width: "80%" }}>{infoCard}</div>
					</Flex>
				</div>
			</div>
		);
	}
	return (
		<Layout
			ref={ref}
			className="landing-page"
			style={{
				backgroundImage: `url(${imageUrl})`,
				backgroundColor: "#000",
				width: "100%",
				height: "auto",
			}}
		>
			<Content className="landing-page-content">
				<Flex gap={16} style={{ padding: "0 10px 20px", color: "#fff" }} justify="space-between" align="center">
					<Flex className="content" justify="left" flex={5} vertical>
						<SweatbaseLogo
							style={{ transform: "scale(.3)", position: "absolute", top: 0, right: "calc(100% - 132px)" }}
						/>
						<Typography.Title style={{ textAlign: "left", fontSize: 14, marginTop: 22 }} level={3}>
							{gymName?.length > 170 ? gymName?.substr(0, 170) + "..." : gymName}
						</Typography.Title>
						<Typography.Paragraph style={{ fontSize: 8, marginTop: 4, height: 80, overflow: "hidden" }}>
							{description?.length > 260 ? description?.substr(0, 260) + "..." : description}
						</Typography.Paragraph>
					</Flex>

					{infoCard}
					<Flex style={{ width: 40 }}>
						<Typography.Text className="login-link" strong>
							LOGIN
						</Typography.Text>
					</Flex>
				</Flex>
				<Row className="mid-section" gap={16}>
					<Col span={8}>
						<Flex vertical align="center" justify="center">
							<div className="sb-landing__characteristics__item__icon-container">
								<div style={{ transform: "scale(.5)" }}>
									<ComputerIcon color={color} />
								</div>
							</div>
							<Typography.Paragraph strong>Anytime Anywhere</Typography.Paragraph>
							<Typography.Paragraph>
								Enjoy workouts from home using your smartphone, computer, tablet, TV, and more... by downloading the
								SWEATBASE App.
							</Typography.Paragraph>
						</Flex>
					</Col>
					<Col span={8}>
						<Flex vertical align="center" justify="center">
							<div className="sb-landing__characteristics__item__icon-container">
								<MusicIcon color={color} />
							</div>
							<Typography.Paragraph strong>Powerful Music</Typography.Paragraph>
							<Typography.Paragraph>
								Our workouts paired with high energy playlists powered by FITRADIO for you to workout at the beat of the
								music.
							</Typography.Paragraph>
						</Flex>
					</Col>
					<Col span={8}>
						<Flex vertical align="center" justify="center">
							<div className="sb-landing__characteristics__item__icon-container">
								<div style={{ transform: "scale(.6)" }}>
									<LiveIcon fill={color} />
								</div>
							</div>
							<Typography.Paragraph strong>Live or on Demand</Typography.Paragraph>
							<Typography.Paragraph>
								Sign up for a live class, or enjoy hundreds of workouts on-demand any time of the day.
							</Typography.Paragraph>
						</Flex>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default LandingPage;
